import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

const LAST_SEEN_KEY = 'sunset_popup_last_seen_v2';
const MS_IN_7_DAYS = 7 * 24 * 60 * 60 * 1000;
const { environment } = window.APP_CONFIG;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const SunsetNotice = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const now = new Date();
    const lastSeenRaw = localStorage.getItem(LAST_SEEN_KEY);
    const lastSeen = lastSeenRaw ? new Date(lastSeenRaw) : null;
    const allowedEnvironment = environment === 'production' || environment === 'sandbox';
    const shouldShow = allowedEnvironment && (!lastSeen || now.getTime() - lastSeen.getTime() > MS_IN_7_DAYS);
    if (shouldShow) {
      setOpen(true);
    }
  }, []);

  const handleClose = (): void => {
    localStorage.setItem(LAST_SEEN_KEY, new Date().toISOString());
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Platform Sunset Notice</DialogTitle>
      <DialogContent>
        <Typography>
          We are actively in the process of sunsetting the Alyce platform. Please reach out to your Account Manager to
          discuss next steps.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="primary">
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SunsetNotice;
